// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__WoMv9","spin":"Spinner_spin__1iTs9"};